import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const Wrapper = styled.div`
  padding: ${rem(8)} ${rem(18)};
  ${({ theme }) => theme.media.fold`
      padding: ${rem(8)} ${rem(20)};
    `}
`;
